import type { AdminAction, AdminUserModel, AuditEntryModel } from '../Models/AdminModel';
import { http } from './httpService';

/**
 * The admin routes.
 *
 * Every one of these is refused by the server for anyone not on the admin
 * list, so hiding the screen is a courtesy rather than the control.
 */
export const AdminService = {
  /** Matches on uid exactly, or on email and display name by substring. */
  searchUsers: (query: string) =>
    http.get<AdminUserModel[]>(`/admin/users?query=${encodeURIComponent(query)}`),

  /** The append-only log of everything that has been done to one account. */
  audit: (userId: string) =>
    http.get<AuditEntryModel[]>(`/admin/users/${encodeURIComponent(userId)}/audit`),

  act: (action: AdminAction, body: { userId: string; months?: number; expiresAt?: string; days?: number; notes?: string }) =>
    http.post<{ userId: string; subscription: unknown }>(`/admin/subscriptions/${action}`, body)
};
